import React from 'react';
import styled from 'styled-components';
import { Card } from 'components';
import { getAltTagFromFileName, slugify } from 'utils';

function OtherShowcases({ cards, backgroundColor, title }) {
  return (
    <>
      <H3 $backgroundColor={backgroundColor}>{title}</H3>
      <Grid className="fade-in">
        {cards.map((node) => {
          const { id, title: _title, images: _images } = node;
          const slug = slugify(_title);
          const mainImage = _images?.[0];
          return (
            <Card
              key={id}
              id={id}
              slug={slug}
              image={mainImage}
              imageWidth={340}
              imageHeight={380}
              title={_title
                .split(' ')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')}
              alt={getAltTagFromFileName(mainImage?.asset?.originalFilename || '')}
            />
          );
        })}
      </Grid>
    </>
  );
}

const H3 = styled.h3`
  background-color: ${({ $backgroundColor }) => $backgroundColor || 'var(--connolly-grey)'};
  color: var(--connolly-black);
  font-size: 2rem;
  grid-column: 1/-1;
  padding: 2.6em 0 1.25em;
  text-align: center;
`;

const Grid = styled.div`
  column-gap: 20px;
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: repeat(9, 1fr);
  margin: 0 auto;
  max-width: 1060px;
`;

export default OtherShowcases;
